import React, { useEffect, useState } from "react";
import { isAuthenticated } from "../auth/helper";
import Menu from "../core/Menu";
import WhatsAppButton from "../core/WhatsAppButton";
import Footer from "../core/Footer";
import AdminApprovalControl from "../core/AdminApprovalControl";
import "../core/AdminApprovalDashboard.css";

const AdminDashboard = () => {
  const [userData, setUserData] = useState(null);

    useEffect(() => {
    const fetchData = async () => {
        const user = await isAuthenticated();
        setUserData(user);
    };

    fetchData();

    // Admin dashboard specific page layout
    document.body.classList.add("admin-dashboard-body");

    return () => {
        document.body.classList.remove("admin-dashboard-body");
    };
    }, []);

  return (
    <div className="dashboard-wrapper admin-dashboard-root">

      <Menu />

      <WhatsAppButton />

      {userData && (
        <main className="admin-approval-page">

          {/* PAGE HEADER */}
          <div className="admin-page-header">

            <div>
              <h1 className="admin-page-title">
                Welcome, {userData.emp_name}
              </h1>

              <p className="admin-page-subtitle">
                Search, filter and export engineer time sheets.
              </p>
            </div>

            <button
              type="button"
              className="admin-timesheets-button"
            >
              <i
                className="fa fa-clock-o"
                style={{ marginRight: "7px" }}
              ></i>

              Time Sheets
            </button>

          </div>

          {/* APPROVAL DASHBOARD */}
          <AdminApprovalControl />

        </main>
      )}

      <Footer />

    </div>
  );
};

export default AdminDashboard;